var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "ruleForm",
      staticClass: "error-form",
      attrs: { model: _vm.formData, "label-width": "0", size: "small" },
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.formData.arr, border: "" } },
        [
          _c("el-table-column", {
            attrs: { label: _vm.$t("vehicle.modelLabel"), "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("vehicle.modelLabel"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "arr." + scope.$index + ".vehicleType",
                              rules: {
                                required: true,
                                message: _vm.$t("basicData.CannotBeEmpty"),
                                trigger: ["blur", "change"],
                              },
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  placeholder: _vm.$t("basicData.PleaseSelect"),
                                },
                                model: {
                                  value: scope.row.vehicleType,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "vehicleType", $$v)
                                  },
                                  expression: "scope.row.vehicleType",
                                },
                              },
                              _vm._l(_vm.modelList, function (item) {
                                return _c("el-option", {
                                  key: item.dictValue,
                                  attrs: {
                                    label: item.dictLabel,
                                    value: item.dictValue,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("basicData.报价模式"), "min-width": "160" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.报价模式"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "arr." + scope.$index + ".quotationMode",
                          rules: {
                            required: true,
                            message: _vm.$t("basicData.CannotBeEmpty"),
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("basicData.PleaseSelect"),
                              clearable: "",
                            },
                            model: {
                              value: scope.row.quotationMode,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "quotationMode", $$v)
                              },
                              expression: "scope.row.quotationMode",
                            },
                          },
                          _vm._l(_vm.QUOTATION_MODEL, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.KilometersStartKM"),
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.KilometersStartKM"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    [5, 6].includes(scope.row.quotationMode)
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "arr." + scope.$index + ".startDistance",
                              rules: {
                                required: true,
                                negative: "",
                                suffix: 2,
                                negative1: 1,
                                package: scope.row.endDistance,
                                validator: _vm.priceType,
                                trigger: ["blur", "change"],
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: scope.row.startDistance,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "startDistance", $$v)
                                },
                                expression: "scope.row.startDistance",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.MileageEndKM"),
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.MileageEndKM"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    [5, 6].includes(scope.row.quotationMode)
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "arr." + scope.$index + ".endDistance",
                              rules: {
                                required: true,
                                negative: "",
                                suffix: 2,
                                negative1: 2,
                                package: scope.row.startDistance,
                                validator: _vm.priceType,
                                trigger: ["blur", "change"],
                              },
                            },
                          },
                          [
                            _c("el-input", {
                              model: {
                                value: scope.row.endDistance,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "endDistance", $$v)
                                },
                                expression: "scope.row.endDistance",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.ExpenseType"),
              "min-width": "160",
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.ExpenseType"))),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "arr." + scope.$index + ".feeTypeCode",
                          rules: {
                            required: true,
                            message: _vm.$t("basicData.CannotBeEmpty"),
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("basicData.PleaseSelect"),
                            },
                            model: {
                              value: scope.row.feeTypeCode,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "feeTypeCode", $$v)
                              },
                              expression: "scope.row.feeTypeCode",
                            },
                          },
                          _vm._l(_vm.feeTypeList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.displayName + "(" + item.code + ")",
                                value: item.code,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: _vm.$t("basicData.Price"), "min-width": "100" },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [_vm._v(_vm._s(_vm.$t("basicData.Price")))]),
                    ]),
                  ]
                },
                proxy: true,
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "arr." + scope.$index + ".price",
                          rules: {
                            required: true,
                            negative: "",
                            suffix: 2,
                            negative1: "",
                            validator: _vm.priceType,
                            trigger: ["blur", "change"],
                          },
                        },
                      },
                      [
                        _c("el-input", {
                          model: {
                            value: scope.row.price,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "price", $$v)
                            },
                            expression: "scope.row.price",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("basicData.operate"),
              width: "100",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-popconfirm", {
                      attrs: {
                        title: _vm.$t("basicData.AreYouSureYouWantToDelete"),
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.handleDel(scope.$index, "collectFeesList")
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "reference",
                            fn: function () {
                              return [
                                _c(
                                  "el-button",
                                  { attrs: { type: "danger", size: "mini" } },
                                  [_vm._v(_vm._s(_vm.$t("basicData.Delete")))]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }